'use strict';

import {isDesktopLarge} from '../helpers/responsiveViewport';

var $holder = $('#flying .flying-tooltip') || {};

function leftNavigatorTooltip () {
  return $holder.tooltip && $holder.tooltip(getOptions());
}

$(window).resize(function () {
  leftNavigatorTooltip();
});

function getOptions () {
  return (!isDesktopLarge()) ? null : 'destroy';
}

module.exports = leftNavigatorTooltip;
